import React from 'react'
import Section from '../components/Section'

function BrandsDirectory() {
	let brandsArr = [
		'123',
		'a',
		'b',
		'c',
		'd',
		'e',
		'f',
		'g',
		'h',
		'i',
		'j',
		'k',
		'l',
		'm',
		'n',
		'o',
		'p',
		'q',
		'r',
		's',
		't',
		'u',
		'v',
		'w',
		'x',
		'y',
		'z'
	]
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Our Brands</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='ad-space__section'>
				<div className='col-12'>
					<img
						src='https://placehold.it/1200x300'
						alt='placeholder'
					/>
				</div>
			</Section>

			<Section id='brands__section'>
				{brandsArr.map((brand, i) => {
					return (
						<div className='col-12' key={i}>
							<div className='row'>
								<div className='col-12'>
									<h3>{brand}</h3>
									<hr />
								</div>
								<div className='col-md-1'>
									{/* spacing column */}
								</div>
								<div className='col-md-11'>
									<ul className='brands-grid'>
										<li>
											<a href='/brand-directory/brand'>
												Brand 1
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 2
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 3
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 4
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 5
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 6
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 7
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 8
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 9
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 10
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 11
											</a>
										</li>
										<li>
											<a href='/brand-directory/brand'>
												Brand 12
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					)
				})}
			</Section>
		</div>
	)
}

export default BrandsDirectory
